import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsClientsTabsTabResidentialCMPrograms from 'components/form-fields-clients-tabs/tab-residential-cm-programs/tab-residential-cm-programs';
// import FormFieldsClientsTabsTabResidentialCMPrograms from 'components/form-fields-clients-tabs/tab-residential-cm-programs/tab-residential-cm-programs-hooks';
class EditViewClientTabResidentialCMPrograms extends Component {
  render() {
    return (
      <div>
        <FormFieldsClientsTabsTabResidentialCMPrograms {...this.props} locked={this.props.locked} />
      </div>
    );
  }
}
EditViewClientTabResidentialCMPrograms.propTypes = {
  locked: PropTypes.bool,
}
EditViewClientTabResidentialCMPrograms = reduxForm({
  form: 'ClientEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewClientTabResidentialCMPrograms);
export default EditViewClientTabResidentialCMPrograms;